$(document).ready(function() {
  /** Auto assign the select variant value to ID field**/
  var selected_option='';
  $('.select__select').each(function(index){
    if(index == 0){
      selected_option= $('option:selected',this).val();
    }else{
      selected_option=selected_option+" / "+$('option:selected',this).val();
    }
  });
  var vID=$(`.variant-custom-data[data-handle="${selected_option}"]`).attr('data-id');
  if(vID != undefined){
    $('.product-form input[name="id"]').val(vID);
  }
  /** Auto assign the select variant value to ID field end HERE**/
  $('.buy-it-now-cstm1').click(function(){
    $(this).parents('.product-form').addClass('buynow');
  });
  $.ajax({
    method: "GET",
    url: "/cart",
    async: false,
    dataType:'json',
    success: function(data) {
      if(data['items'].length == 1 && data['items'][0]['properties']['_upsell'] =='upsell'){
        var vID= data['items'][0]['id'];
        $.ajax({
          method: "POST",
          dataType: 'json',
          url:'/cart/change.js',
          async: false,
          data:{'id': vID, 'quantity': 0},
          success: function(data) {
            if(window.location.href.indexOf('/cart') > -1){
              location.reload();
              //          $.ajax({
              //      method: "GET",
              //      url: "/cart",
              //      async: false,
              //      success: function(data) {
              //       // console.log($('cart-items',data).html());
              //    $('cart-items').html($('cart-items',data).html());
              //      $('.cart__footer').html($('.cart__footer',data).html()); 
              //    },
              //    error:function(response){
              //     location.reload();
              //   }
              // });
            }
          }
        });  
      }
    }
  });

  
  $(".multicolumn-list__item").click(function(){
    var collurl = $(this).attr("data-url");
    window.location.href=collurl;    
  }); 
  /** announcement bar ***/
  if ($('.announcement-bar').length) {
    if($('.announcement_cross_btn').attr('data-time') ==  'false'){
      if (localStorage.getItem('barDismissed')) {
        $(".announcement-bar").slideUp();
        $("body").addClass("no-announcement-bar");
      } else {
        $(".announcement-bar").show();
      }
    }  
    else {$(".announcement-bar").show();}
    $('.announcement_cross_btn').click(function() {
      $(".announcement-bar").slideUp();
      $("body").addClass("no-announcement-bar");
      localStorage.setItem('barDismissed', true);
    }); 
  }
  /** announcement bar ***/
  if($('.multicolumn-slider').length >  0){
    $('.multicolumn-slider').flickity({
      // cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      adaptiveHeight: true,
      groupCells: true,                                
      lazyLoad: true ,                              
      arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
      on: {
        ready: function() {
          $('.flickity-button svg').attr('viewBox','0 0 12 13');
          $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
        }
      }
    });
  }

  /** banner slider ***/
  if($('.slideshow-main .slideshow').length >  0){
    $('.slideshow-main .slideshow').each(function(){
      var pageDots = $(this).attr('data-dots');
      var autoplay = $(this).attr('data-autoplay');
      var speed = parseInt($(this).attr('data-speed'));  
      var arrows = $(this).attr('data-arrows'); 
      if(autoplay ==  'true'){
        autoplay = speed*1000;
      }
      else{autoplay = false}
      var arrows = arrows == "true" ? true : false;
      var pageDots = pageDots == "true" ? true : false;
      $(this).flickity({
        // cellAlign: 'left',
        contain: true,
        pageDots: pageDots,
        wrapAround: false,
        adaptiveHeight: true,
        groupCells: true,
        autoPlay:autoplay,
        lazyLoad: true ,
        prevNextButtons: arrows,
        arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
        on: {
          ready: function() {
            $('.flickity-button svg').attr('viewBox','0 0 12 13');
            $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
            console.log('Flickity is ready');
          }
        }
      });
    });       
  }

  /** banner slider end here ***/
  /*** Marquee slider ****/
  if($('.flickity_marquee').length >0){
    var width = $(window).width();
    if (width > 601) {
      var tickerSpeed = 1;
    }else{
      var tickerSpeed = 1;
    }

    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector('.flickity_marquee');

    const update = () => {
      if (isPaused) return;
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25
    });
    flickity.x = 0;

    slideshowEl.addEventListener('mouseenter', pause, false);
    slideshowEl.addEventListener('focusin', pause, false);
    slideshowEl.addEventListener('mouseleave', play, false);
    slideshowEl.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
      isPaused = true;
    });

    update();
  }

  /*** Marquee slider END HERE****/
  /*** Open sub menu on click on menu item in Megamenu ****/
  $('.mega-menu__list-new li a.has-sub-menu').click(function(e){
    e.preventDefault();
    $('.mega-menu__list-new li a.has-sub-menu').removeClass('active');
    $(this).addClass('active');
    var sub_menu_handle = $(this).attr('data-parent-menu');
    $('.sub-menu-level-3').hide();
    $('.sub-menu-level-3[data-parent-menu="'+sub_menu_handle+'"]').show();
  });

  /*** Open sub menu on click on menu item in Megamenu END HERE****/
  /*** Collage slider for mobile only ***/  
  if($('.collage-mobile-slider').length > 0){
    $('.collage-mobile-slider').flickity({ cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
    lazyLoad: true,
    watchCSS: true,
    arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
    on: {
      ready: function() {
        $('.flickity-button svg').attr('viewBox','0 0 12 13');
        $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
        //console.log('Flickity is ready');
      }
    }               
  });
  }

  /*** Collage slider for mobile only END HERE***/    
  /***** Collection page featured products slider ****/
  if($('.col-featured-mobile-slider').length > 0){
    $('.col-featured-mobile-slider').flickity({ 
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      adaptiveHeight: false,
      lazyLoad: true,
      watchCSS: true,
      arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
      on: {
        ready: function() {
          $('.flickity-button svg').attr('viewBox','0 0 12 13');
          $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
          //console.log('Flickity is ready');
        }
      }               
    });
  }

  /***** Collection page featured products slider END HERE ****/
  // quality page js
  if (window.location.href.indexOf('quality?') > -1) {
    var hash = window.location.href.split('?')[1];
    if (hash.length) {
      $('html, body').animate({
        scrollTop: $('#'+hash).offset().top
      }, 500, 'swing');
    }
  }

  // quality page js end here 
  $(document).on('click', '.page_link_outer a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

  // quality page js end
  /*** close other tabs when click on accordian tab ***/
  $('.accordion details').on('click',function(){
    $(this).attr('open');
    $(this).parent('.accordion').siblings().find('details').removeAttr('open');
  });

  /*** close other tabs when click on accordian tab END HERE ***/
  /*** close other tabs when click on mobile menu tab ***/
  $('.menu-drawer__menu-item').on('click',function(){
    $(this).parents('.menu-drawer__menu').find('li details').not($(this).parents('details')).removeAttr('open');
  });    
      
  /*** close other tabs when click on mobile menu tab END HERE ***/
  /**** Bundle product variant Options ON LOAD****/
  function eventFire(el, etype){
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  /** genrate random No ***/
  let r = (Math.random() + 1).toString(36).substring(2);
  if($('.mainP_random').length > 0){
    $('.mainP_random, .bundle_random').val(r);
  }

  /** genrate random No end here***/
  if($('.bunddle_inner_outer').length >0){
    // $('.product__info-wrapper  .price__container').hide();
    var total = $('.bunddle_inner_outer').length;
    $('.bunddle_inner_outer').each(function(index){
      var get_option=[];
      var option_avail=[];
      var check_option_count=0;
      var first_select_val = $('variant-selects .product-form__input:first-child select option:selected',this).val();
      $('.main_Select option',this).each(function(){
        var e = $(this).val();
          if(e.indexOf('/') > -1){
            check_option_count=1;
            if(e.indexOf(first_select_val) > -1){
              var second_option = $.trim(e.split('/')[1]);
              get_option.push(second_option);
              option_avail.push($(this).attr('data-available'));
            }
          }
          else{
            var second_option = $.trim(e);
            get_option.push(second_option);
            option_avail.push($(this).attr('data-available'));
          }
      });
      console.log(get_option);
      if(get_option.length ==1 && get_option[0] == 'Default Title' ){ 
        var totalPrice =parseFloat($('.product__info-wrapper .main_org_price').attr('data-price'));
        var discountedPrice =parseFloat($('.product__info-wrapper .main_sale_discount_price').attr('data-price'));
        var saveprice = totalPrice -discountedPrice;
        var saveprice = (saveprice).toFixed(2);
        saveprice = Shopify.formatMoney(`${saveprice}`); 
        $('.product__media-gallery .product_badge.on_sale').show();
        $('.product__media-gallery .product_badge.on_sale span').text(`SAVE ${saveprice}`);
      }
      if(get_option.length > 0){
        var i=0;
        $('variant-selects .product-form__input:nth-child(2) select option ',this).each(function(){
          if ($.inArray($(this).val(), get_option) == -1){
            $(this).hide();
          }else{
            $(this).show();
            var get_avail_val = option_avail[i];
            if(get_avail_val == 'false'){
              $(this).attr('disabled','disabled').addClass('voutStock');
              if($(this).text().indexOf('(Out of stock)') == -1){
                $(this).append('(Out of stock)');
              }
            }else{
              $(this).removeAttr('disabled').removeClass('voutStock');
              if($(this).text().indexOf('(Out of stock)') > -1){
                $(this).replace('(Out of stock)','');
              }
            }
            i++;
          }
        });
        if(check_option_count == 0){
          $('variant-selects .product-form__input:nth-child(1) select option ',this).each(function(){
            if ($.inArray($(this).val(), get_option) == -1){
              $(this).hide();
            }else{
              $(this).show();
              var get_avail_val = option_avail[i];
              if(get_avail_val == 'false'){
                $(this).attr('disabled','disabled').addClass('voutStock');
                if($(this).text().indexOf('(Out of stock)') == -1){
                  $(this).append('(Out of stock)');
                }
              }else{
                $(this).removeAttr('disabled').removeClass('voutStock');
                if($.trim($(this).text()).indexOf('(Out of stock)') > -1){
                  var t=$(this).text();
                  var t1= t.replace('(Out of stock)','');
                  $(this).text(t1);
                }
              }
              i++;
            }
          });
        }
        //console.log(this);
        var flag= 0;
        var sel_option=get_option[0];
        $(this).find('variant-selects .product-form__input:nth-child(2) select option').each(function(){
          if(flag == 0){
            if($(this).css('display') == 'block'){
              if(!($(this).hasClass('voutStock'))){
                flag=1; 
                sel_option= $(this).val(); 
              }
            }
          }
        });
      
        $(this).find('variant-selects .product-form__input:nth-child(2) select option:selected').removeAttr('selected');
        $(this).find(`variant-selects .product-form__input:nth-child(2) select option[value="${$.trim(sel_option)}"]`).attr("selected","selected");
        $(this).find('variant-selects .product-form__input:nth-child(2) select').val($.trim(sel_option)).change();
        $(this).find('variant-selects .product-form__input:nth-child(2) select').trigger('click');
        var selectId=$(this).find('variant-selects .product-form__input:nth-child(2) select').attr('id');
        var selectId1=$(this).find('variant-selects .product-form__input:nth-child(1) select').attr('id');
        // alert(selectId1);
        if(selectId1 != undefined){
          setTimeout(function(){eventFire(document.getElementById(selectId1), 'change');},500);
        }
        if(selectId != undefined){
          setTimeout(function(){eventFire(document.getElementById(selectId), 'change');},500);
        }
        //   var el = document.querySelector("variant-selects .select__select");
        //  el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (index === total - 1) {
        setTimeout(function(){$('.product__info-wrapper  .price__container').show();},1500);
      }
    });
  }

  /**** Bundle product variant Options END HERE****/
  /*** Bundle Product on change select box ***/
  $('variant-selects .product-form__input:first-child select').change(function(){
    var get_option=[];
    var option_avail=[];
    var first_select_val = $('option:selected',this).val();
    $(this).parents('.bunddle_inner_outer').find('.main_Select option').each(function(){
      var e = $(this).val();
      if(e.indexOf(first_select_val) > -1){
        var second_option = $.trim(e.split('/')[1]);
        option_avail.push($(this).attr('data-available'));
        get_option.push(second_option);
      }
    });
    console.log(option_avail);
    if(get_option.length > 0){
      var i=0;
      $(this).parents('.bunddle_inner_outer').find('variant-selects .product-form__input:nth-child(2) select option').each(function(index,val){ 
        if ($.inArray($(this).val(), get_option) == -1){
          $(this).hide();
          $(this).removeAttr('selected');
        }
        else{
          $(this).show();
          var get_avail_val = option_avail[i];
          if(get_avail_val == 'false'){
            $(this).attr('disabled','disabled').addClass('voutStock');
            if($(this).text().indexOf('(Out of stock)') == -1){
              $(this).append('(Out of stock)');
            }
          }else{
            $(this).removeAttr('disabled').removeClass('voutStock');
            if($.trim($(this).text()).indexOf('(Out of stock)') > -1){
              var t=$(this).text();
              var t1= t.replace('(Out of stock)','');
              $(this).text(t1);
            }
          }
          i++;
        }
      });
      $(this).parents('.bunddle_inner_outer').find('variant-selects .product-form__input:nth-child(2) select option').removeAttr('selected');
      $(this).parents('.bunddle_inner_outer').find('variant-selects .product-form__input:nth-child(2) select').val(get_option[0]).change();
    }
  });

  /*** Bundle Product on change select box END HERE***/
  /*** Check the sold out product ***/
  if($('.bundle_inner').length > 0){
    if($('.bundle_inner').hasClass('bundle_sold_out')){
      $('.product-form__submit').attr('disabled','disabled');
      $('.product-form__submit span').text('Out of stock');
      $('#badge .out_stock').show();
      $('.product__media-wrapper').attr('data-sold',true);
    }
    else{
      $('#badge .out_stock').hide();
      $('.product__media-wrapper').attr('data-sold',false);
    }
  }

  /*** Check the sold out product END here***/
  if(sessionStorage.getItem("fintessPopup") == null){
    $('.fitness-popup-outer[data-show="true"]').css('display','flex');
  }

  /*** Popup close function ***/
  $(document).on('click','.close-popup-icon svg, .close-popup',function(){
    sessionStorage.setItem("fintessPopup", "true");
    $(this).parents('.fitness-popup-outer').hide();
  });

  /*** Popup close function END HERE***/
  /*** Add fitness on product on cart page ***/ 
  $(document).on('click','.add-fitness',function(e){
    e.preventDefault();
    var _this = $(this);
    var this1=this;
    var items = {};
    var product_data=[];
    var vID=$(this).attr('data-vid');
    items['id'] = vID;
    items['quantity'] =1;
    if($('.discount_properties').length >0){
      var selectVariant=false;
      if($(this).attr('select-variant') == 'true'){
        selectVariant=true;
      }
      var discount_message =$('.discount_properties.discount_message').val();
      var discount_value =$('.discount_properties.discount_value').val();
      items['properties']= {"_selectVariant":selectVariant,"_discount_value":discount_value,"_discount_message":discount_message,"_upsell":"upsell"};
    }
    product_data.push(items);
    _this.addClass('loading');
    $('.loading-overlay__spinner',this).removeClass('hidden');
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: "/cart/add.js",
      async: false,
      data:{items:product_data},
      success: function(data) {
        //console.log(data);
        $.ajax({
          method: "GET",
          url: "/cart",
          async: false,
          success: function(data) {
            _this.removeClass('loading');
            $('.loading-overlay__spinner',this1).addClass('hidden');
            //console.log(data);
            $('cart-items').html($('cart-items',data).html());
            $('.cart__footer').html($('.cart__footer',data).html()); 
          },
          error:function(response){
            location.reload();
          }
        });
      },
      error:function(response){
        console.log(response.responseJSON.description);
        $(`<p class="error-msg">${response.responseJSON.description}</p>`).insertAfter(_this);
        _this.classList.remove('loading');
        $('.loading-overlay__spinner',this1).classList.add('hidden');
        setTimeout(function(){$('.error-msg').remove();},2000);
        return;
      }
    });
  });

  /*** Add fitness on product on cart page END HERE***/ 
  /*** Add fitness variant selection box ***/
  $(document).on('click',".upsell-variant-id",function() {
    var is_open = $(this).hasClass("open");
    if (is_open) {
      $(this).removeClass("open");
    } else {
      $(this).addClass("open");
    }
  });

  $(document).on('click','.upsell-variant-id li',function() {
    var selected_value = $(this).html();
    var selected_variant = $(this).attr('value');
    var first_li = $(".upsell-variant-id li:first-child").html();
    $(".upsell-variant-id li:first-child").html(selected_value);
    $('.add-fitness').attr('data-vid',selected_variant);
    $(this).html(first_li);
    $('.add-fitness').attr('select-variant',true);
  });

  $(document).mouseup(function(event) {
    var target = event.target;
    var select = $(".upsell-variant-id");
    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
    }
  });

  /*** Add fitness variant selection box END HERE***/
  /*** Cancel the fitness product ***/
  $(document).on('click','.remove-fitness',function(){
    $(this).parents('.fitness-add-row').remove();
  });

  /*** Cancel the fitness product END HERE***/
  /*** Auto add the discounted product on cart page ***/
  if($('.fitness-add-row.auto-add').length > 0){
    $('.fitness-add-row .add-fitness').trigger('click');
  }

  /*** Auto add the discounted product on cart page END HERE***/
  /*** Close the popup when click outside ***/
  $('body').click(function(e) {
    if (!$(e.target).closest('.fitness-popup-inner').length){
      $(".fitness-popup-outer").hide();
    }
  });

  /*** Close the popup when click outside END HERE***/   
  $(document).on('click','.yotpo-campaign-switcher-wrapper', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.yotpo-widget-referral-widget').offset().top
    }, 2000); 
  });
}); // ready function end here

$(window).on("load resize",function(e){
  $('.card__media').each(function(){
    var h=$(this).height() -45;
    $(this).parents('.card').find('.combo_badge').css('top',h);
  });
  $('.collection .slider-buttons').each(function(){
    $(this).parents('.collection').find('.card-wrapper .card__inner').outerHeight()/2;
    var ih= $(this).parents('.collection').find('.card-wrapper .card__inner').outerHeight()/2;
    $(this).css('top',ih+'px');
  });
});

/*** add product on click on buy now button***/
$(document).on('click','.buy-it-now-cstm',function(e){
  var product_data= $(this).parents('.product-form').find('form').serialize();
  var this1=this;
  var _this = $(this);
  _this.addClass('loading');
  $('.loading-overlay__spinner',this).removeClass('hidden');
  e.preventDefault();
  $.ajax({
    method: "POST",
    dataType: 'json',
    url: "/cart/add.js",
    async: false,
    data:product_data,
    success: function(data) {
      //console.log(data);
      window.location.href='/checkout'
    },
    error:function(response){
      console.log(response.responseJSON.description);
      $(`<p class="error-msg">${response.responseJSON.description}</p>`).insertAfter(_this);
      //    _this.classList.remove('loading');
      //$('.loading-overlay__spinner',this1).classList.add('hidden');
      setTimeout(function(){$('.error-msg').remove();},2000);
      return;
    }
  });
}); 

// landing page scroll on form
$(document).on('click', 'a.pw__button', function (e) {
  e.preventDefault();
  var $target = $('.pxFormGenerator').first();
  if (!$target.length) {
    $target = $('iframe[title="Engen Competition"]').first();
  }
  if ($target.length) {
    var offset = 120; // sticky header ki height ke hisaab se adjust karo
    $('html, body').animate({
      scrollTop: $target.offset().top - offset
    }, 600);
  }
});
